import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/card";
import Spinner from "@/atomic/atoms/Spinner";
import Modal from "@/atomic/atoms/Modal";
import OrgPayment from "@/atomic/organisms/orgPayment";
import { Suspense } from "react";

export default function RechargeCardView({
  isLoading,
  goBack,
  payment,
  activeCard,
  onChangeCard,
  creditCard,
  cards,
  error,
  setError,
}: PropsView) {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-4 w-full flex flex-col flex-1">
        <div className="max-w-2xl mx-auto w-full flex flex-col flex-1">
          <article className="flex flex-col flex-1">
            <div className="flex flex-col flex-1 w-full max-w-[480px] mx-auto">
                <h2 className="text-black font-bold text-xl my-4 mx-2">Cartão de Crédito</h2>              
                {!isLoading && cards?.length === 0 ? (
                  <div className="space-y-7 flex-1 flex flex-col justify-center pb-24">
                    <div className="flex flex-col w-full items-center justify-center">
                      <img 
                        src={"/icon-credit-card-close.png"}
                        width={145}
                        height={145}
                        alt="icon credit card"
                        className="mt-2"
                      />
                      <h2 className="px-20 mt-2 text-base text-black text-center">Ei, você ainda não tem nenhum cartão cadastrado.</h2>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-7">
                    {cards?.map((item, index) => (
                    <div 
                      key={index} 
                      onClick={() => onChangeCard(0)}
                      className={`flex-col items-center gap-2 rounded-lg border ${
                        activeCard === 0 ? 'border-black' : 'border-gray-300'
                      } bg-white cursor-pointer`}
                    >
                      <div className="flex-1 text-left p-4 flex items-center justify-between">
                        <div className="flex">
                          {(item.brand === 'visa' || item.brand === 'mastercard' || item.brand === 'amex' || item.brand === 'elo') && (
                            <img 
                              src={`/icon-credit-card-${item.brand}.png`}
                              width={70}
                              height={45}
                              alt="icon credit card"
                              className="mr-1"
                            />
                          )}
                        </div>

                        <div className="flex-1 px-2">
                          <div className="flex w-full justify-start">
                            <p className="bg-black text-white text-sm px-1 rounded-md">
                              Cartão de Crédito
                            </p>
                          </div>
                          <p className="text-black text-md">{item.number}</p>
                        </div>
                        
                        <div className="flex items-center ml-3">
                          {activeCard === 0 ? (
                            <img 
                              src={"/icon-checked.png"}
                              width={16}
                              height={16}
                              alt="selected"
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ))}
                  </div>
                )}
            </div>
          </article>
        </div>
      </main>
      <OrgPayment 
        textLabel="Pagar"
        onClick={payment}
      />
      {error && <Suspense fallback={null}>
        <Modal
          title="Ops!"
          message="Não foi possível fazer seu pagamento!"
          actionMessage="Tentar novamente"
          action={payment}
          actionSecondMessage="Ok, entendi"
          actionSecond={() => setError(false)}
        />
      </Suspense>}
      {isLoading && <Spinner />}
    </div>
  );
}
